import React from 'react';
import VideoCategoryPage from '../components/VideoCategoryPage';

function ViralVideos() {
  return (
    <VideoCategoryPage
      category="viral"
      badge="Trending Stream"
      title="वायरल विडियोज़"
      subtitle="सबसे ज्यादा देखी जाने वाली विडियोज़ अब सीधे इसी पेज पर चलेंगी"
      description="ट्रेंडिंग क्लिप्स, तेज़ कवरेज और सबसे ज्यादा देखी जा रही वीडियो स्टोरीज़ को एक curated stream में देखें।"
      emptyMessage="वायरल सेक्शन के लिए नए वीडियो जल्द जोड़े जाएंगे।"
      accentClass="video-page-viral"
    />
  );
}

export default ViralVideos;
